import { render, staticRenderFns } from "./additionBe.vue?vue&type=template&id=aaa24410&scoped=true"
import script from "./additionBe.vue?vue&type=script&lang=js"
export * from "./additionBe.vue?vue&type=script&lang=js"
import style0 from "./additionBe.vue?vue&type=style&index=0&id=aaa24410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa24410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
